import React, { useEffect, useState } from 'react';

const SuccessPopup = (props) => {
     return (
        <div className='popup-overlay import-popup'>
            <div className='popup-import-report'>
                <i onClick={ props.toggleImportSuccessPopup }>
                    <svg width="15" height="10" viewBox="0 0 15 15">
                    <path class="a" d="M30.78,16.22a.749.749,0,0,0-1.06,0l-6.22,6.22-6.22-6.22a.75.75,0,0,0-1.06,1.06l6.22,6.22-6.22,6.22a.75.75,0,1,0,1.06,1.06l6.22-6.22,6.22,6.22a.75.75,0,0,0,1.06-1.06L24.56,23.5l6.22-6.22A.749.749,0,0,0,30.78,16.22Z" transform="translate(-16 -16)"></path>
                    </svg>
                </i>
                <h3>File Imported Successfully !</h3>
                <p>Success Count : <span className='green-txt'>{ props.appAccessControlImportUsers?.data?.successCount }</span></p>
                <p>Error Count : <span className='red-txt'>{ props.appAccessControlImportUsers?.data?.errorCount }</span></p>
                <p>Duplicate Count : <span className='red-txt'>{ props.appAccessControlImportUsers?.data?.duplicateCount }</span></p>
                <button className='blue-bbt btn btn_primary' onClick={ props.toggleImportSuccessPopup }>Ok</button>
            </div>
        </div>
     )
}

export default SuccessPopup;